import { combineReducers } from 'redux'
import notificationReducer from './notificationReducer'

// import todoReducer from "./reducers/todoReducer";
import logErrorReducer from './logErrorReducer'
// import todoReducer from './gameBuilderReducer'
import gameReducer from './gameReducer'

const rootReducer = () =>
  // const rootReducer = (history: any) =>
  combineReducers({
    // router: connectRouter(history),
    // gameBuilder: gameBuilderReducer,
    // todo: todoReducer,
    notification: notificationReducer,
    logError: logErrorReducer,
    // moderator: moderatorReducer,
    game: gameReducer,
  })

export default rootReducer
